import type { UserContextType } from '@/client/context/user'

// This checks whether a user object represents a valid logged-in state
// as opposed to a default.
export default function isUserDefined(user: UserContextType): boolean {
  return !(user == null || user.isLoggedOut || user.id == null || user.id === 0)
}
